// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeController_inputRoot__3b0fv","arrowIcon":"DateRangeController_arrowIcon__2gY2M"};